import {useEffect, useState} from 'react'
import {UserAPI} from '../../apis/UserAPI'
import useAuthStore from '../../stores/authStore'

export const useUsers = () => {
    const [users, setUsers] = useState([])
    const [filters, setFilters ] = useState({})
    const currentUser = useAuthStore((state) => state.user)
    //console.log('user', user)
    const fetchUsers = async () => {
        const resp = await UserAPI.getAll({ user_id: currentUser._id, ...filters })
        //console.log(resp.users)
        setUsers(resp.users)
    }
    useEffect(() => {
        fetchUsers()
    }, [filters])

    return { users, fetchUsers, setFilters, filters }
}
